import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import NavbaR from "../Navbar/NavbaR";
import {BsDot} from 'react-icons/bs';
import "./Agriculture.css";

export default function Agriculture() {
  return (
    <div className="strategy-main">
    <div className="agriculture-top-div">
      <div><NavbaR/></div>
      <h1 className="strategy-label">Agriculture</h1>
    </div>

    <div className="strategy-evaluation-main">
      <h3 className="strategy-evaluation-title">Special Situations Investment Company</h3>
      <div className="title-placer" style={{width:'16rem'}}>&nbsp;</div>
      <p className="evaluation-details"  id='evaluation-details-id'>Eram Capital Partners collaborates with small to medium size private and public companies operating in the agricultural sector in United Kingdom, Europe and North America. Eram develops opportunities for partnership and investment with companies who have expertise and growth prospects in the following industries:
      </p>

    </div>

    <div className="evaluation-points-main">
      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">	Dairy and milk products</p>
      </div>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">	Industrial grains: wheat, barley, etc</p>
      </div>
      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">Poultry, beef, and fish farm operations</p>
      </div>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">		Forestry operations</p>
      </div>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">	Agrochemicals, equipment, and logistics</p>
      </div>
    </div>

        <p className="evaluation-details">Eram believes in the global trend toward greater investment in the agricultural sector for financial and strategic reasons. Eram and our co-investor partners believe in the global demographic factors stimulating this growth, governed largely by:</p>

        <div className="evaluation-points-main">
        <div className="evaluation-point">
          <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
          <p className="evaluation-point-details">		Increased energy and water resource demand for non-agricultural activities which is restraining supply in the agricultural sector.</p>
        </div>
        <div className="evaluation-point">
          <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
          <p className="evaluation-point-details">			Decrease in land available for certain large-scale agricultural activities due to population growth, land prices for real estate development, and government restrictions.</p>
        </div>

        <div className="evaluation-point">
          <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
          <p className="evaluation-point-details">	Increase in food and basic materials consumption driven by global economic growth and global population growth in developed and developing countries.</p>
        </div>
       </div>

        <p className="evaluation-details">Eram Capital has unique access to strategic and financial investors globally who have an abundance of capital resources and understand the global demographic trends driving the agricultural sector. Eram and its co-investor partners have a long history of agricultural sector experience in key geographies around the world. We can provide development capital, growth capital for companies and projects for foreign expansion and can facilitate commercial partnerships locally.
    </p>

  </div>
  );
}
